module.exports = __webpack_public_path__ + "static/img/china_bg1.176b0a4d.png";